import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import TourPackages from "@/pages/TourPackages";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster
          position="top-center"
          theme="dark"
          toastOptions={{
            style: {
              background: "#131B2A",
              color: "#F8FAFC",
              border: "1px solid rgba(212,175,55,0.3)",
              borderRadius: 0,
            },
          }}
        />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/packages" element={<TourPackages />} />
          <Route path="/admin/bookings" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
